<!-- `actionButtons` is what `resolveButton()` produced, so everything here is already
     resolved: `buttonIcon` and `buttonClass` come from the renderer's own icon set
     (`icon-buttons-renderer.constants.ts`) keyed on `userAction`, `disableProperty` and
     `hideProperty` arrived as row-flag NAMES and are now plain booleans, and the array is
     already sorted so edit and delete sit last.
     `disabled-state` greys the icon; `[disabled]` is what stops a greyed icon still firing.

     `item.buttonIcon` is part of the condition because an icon button with no icon is not
     a button. A column whose `cellRendererSelector` can hand the same param array to
     `buttonsRenderer` carries label-only entries meant for that renderer; `resolveButton()`
     deliberately gives those no default icon, and this is what then keeps them out. -->
@for(item of actionButtons; track item; let i = $index){
    @if(!item.hideProperty && item.buttonIcon){
    <button [class]="item.buttonClass" [ngClass]="{'disabled-state': item.disableProperty }"
        [disabled]="item.disableProperty" [ngbTooltip]="item.buttonTooltip" placement="left"
        container="body" (click)="onUserAction(item.userAction);">
        <img [src] = "item.buttonIcon" alt="">
    </button>
    }
}
